import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function CancelIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <circle r={6.25} stroke={color || defaultColor} fill="none" transform="matrix(-1 0 0 1 7 7)" />
    <path stroke={color || defaultColor} fill="none" strokeLinecap="round" d="M11.4172 11.4172L2.58265 2.58265" />
  </SvgIcon>
}
